import { BoxProps, VStack } from "@chakra-ui/react";
import React from "react";

export const CardList: React.FC<BoxProps> = ({ children, ...boxProps }) => {
    return (
      <VStack
        align={"stretch"}
        spacing={[null, null, null, 0.5, null]}
        w={"100%"}
        {...boxProps}
  
      >
        {children}
      </VStack>
    );
  };